<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  let { admin, minimum_password_length: minimumPasswordLength } = $props()

  // Validation is the server's: each change is checked live by a Precognition request to
  // the real update action, and again on Save.
  const form = useForm({
    admin: {
      name: admin.name ?? '',
      email: admin.email ?? '',
      password: '',
      password_confirmation: '',
      current_password: ''
    }
  }).withPrecognition('patch', '/account')
  liveValidate(form, 'admin')

  const submit = (event) => {
    event.preventDefault()
    $form.patch('/account', {
      onFinish: () => {
        $form.admin.password = ''
        $form.admin.password_confirmation = ''
        $form.admin.current_password = ''
      }
    })
  }
</script>

<Layout>
  <PageHeader title="Account Settings" subtitle="Your admin profile and password" />

  <FormLayout onsubmit={submit}>
    <FormSection title="Profile">
      <TextField bind:value={$form.admin.name} label="Name" name="name" error={$form.errors['admin.name']} />
      <TextField bind:value={$form.admin.email} label="Email" name="email" type="email" error={$form.errors['admin.email']} />
    </FormSection>

    <FormSection title="Change Password">
      <TextField
        bind:value={$form.admin.password}
        label="New Password"
        name="password"
        type="password"
        autocomplete="new-password"
        help={`Leave blank to keep your current password. Minimum ${minimumPasswordLength} characters.`}
        error={$form.errors['admin.password']}
      />
      <TextField
        bind:value={$form.admin.password_confirmation}
        label="Confirm New Password"
        name="password_confirmation"
        type="password"
        autocomplete="new-password"
        error={$form.errors['admin.password_confirmation']}
      />
    </FormSection>

    <FormSection title="Confirm Changes">
      <TextField
        bind:value={$form.admin.current_password}
        label="Current Password"
        name="current_password"
        type="password"
        autocomplete="current-password"
        help="We need your current password to confirm any change."
        error={$form.errors['admin.current_password']}
      />

      {#if $form.errors['admin.base']}<p class="text-sm text-error">{$form.errors['admin.base']}</p>{/if}
    </FormSection>

    {#snippet footer()}
      <SubmitButton processing={$form.processing} label="Save Changes" full={false} />
    {/snippet}
  </FormLayout>
</Layout>
